import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import api from '../../services/api';
import { Creators as NewspapersCreators, Types as NewspapersTypes } from '../ducks/newspapers';

export function* fetchNewspapers({ type }) {
  const mapActionToURLs = {
    [NewspapersTypes.GET_BANNERS]: 'banners',
    [NewspapersTypes.GET_RECENTS]: '',
    [NewspapersTypes.GET_REGIONALS]: 'geolocation',
    [NewspapersTypes.GET_HIGHLIGHTS]: 'highlights',
  };

  const response = yield call(api.get, `v2/newspapers/${mapActionToURLs[type]}`);

  if (response.ok) {
    yield put(NewspapersCreators.setNewspapers(type.replace('GET', 'SET'), response.data));
  }
}

export function* fetchFavoritesNewspapers({ payload }) {
  const response = yield call(api.get, 'v2/newspapers/favorites', {
    customer_id: payload,
  });

  if (response.ok) {
    yield put(NewspapersCreators.setNewspapers(NewspapersTypes.SET_FAVORITES, response.data));
  }
}

export function* searchNewspapers(params) {
  const apiParams = {};
  var urlRedirect = '/jornais/todos';
  if (params.payload.uf && params.payload.uf !== 'todos') {
    apiParams.uf = params.payload.uf.toUpperCase();
    var urlRedirect = `/jornais/${params.payload.uf}`;
  }
  if (params.payload.query) {
    apiParams.query = params.payload.query;
    var urlRedirect = `/jornais/todos?q=${apiParams.query}`;
  }
  const response = yield call(api.get, 'v2/newspapers/search', apiParams);

  yield put(push(urlRedirect));

  if (response.ok) {
    yield put(NewspapersCreators.setNewspapers(NewspapersTypes.SET_SEARCH, response.data));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/newspapers.js